import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import style from './ForceDisableCheckbox.module.scss';

interface IProps {
	toggleForceDisable: () => void;
	forceDisable: boolean;
}

export const ForceDisableCheckbox: React.FC<IProps> = React.memo(({ toggleForceDisable, forceDisable }) => {
	return (
		<Form.Item className={style.container} name="forceDisable" data-test="ForceDisableCheckbox">
			<Checkbox onChange={toggleForceDisable} checked={forceDisable}>
				<Text translationNameSpace="form" translationKey="isForceDisabledLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
});
